/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=72b05273&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\weilaiyinke-duimi-frontend-collection-app-user-college-\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b05273"]])

export default __exports__